document.addEventListener("DOMContentLoaded", async function () {
  async function handleMutations() {
    const isFrench = window.location.pathname.startsWith('/fr/collections/');
      if (!isFrench) return;

      const customOverrides = {
          'tie-dye': ['teinture-cravate'],
          'grey-tie-dye': ['teinture-gris'],
          'tie-dye-smiley': ['smiley-tie-dye'],
          'outer-space': ['cosmos'],
          'green-camo-reflective': ['camouflage-vert-réfléchissant'],
          'pink-houndstooth': ['pied-de-poule-rose'],
          'glow-in-the-dark-marble': ['marbre-qui-brille-dans-le-noir'],
          'wet-reveal-clouds': ['nuages-révélateurs-humides'],
          'wet-reveal-unicorns': ['licornes-révélatrices-humides'],
          'army-green': ['armée-verte'],
          'grey-mix': ['mélange-de-gris'],
          'black-crackle': ['crépitement-noir'],
          'tan': ['bronzer'],
          'ice-blue': ['glace-bleue'],
          'light-pink': ['rose-clair'],
          'dark-pink': ['rose-foncé'],
          'green-smiley': ['smiley-vert'],
          'purple-smiley': ['smiley-violet'],
          'teal-frog': ['grenouille-sarcelle'],
          'popsicle': ['glace-glacée'],
          'rubber-ducks': ['canards-en-caoutchouc'],
          'pink-purple': ['rose-mauve'],
          'blue-teal': ['bleu-sarcelle'],       
          'brown-dog': ['chien-marron'],
          'pink-plaid': ['plaid-rose'],   
          'red-plaid': ['plaid-rouge'],
          'blue-plaid': ['plaid-bleu'],
          'black-camo': ['camouflage-noir'],
          'forest-green': ['foret-verte'],
          'neon-pink': ['rose-neon'],
          'blue-green': ['bleu-vert'],
          'rainbow': ['arc-en-ciel'],
          'splatter': ['eclabousser'],
          'glow-in-the-dark': ['brillent-dans-le-noir'],
          'pink-reflective-camo': ['camouflage-réfléchissant-rose'],
          'red-reflective': ['rouge-réfléchissant'],
          'pink-reflective': ['rose-réfléchissant'],
          'black-reflective': ['noir-réfléchissant'],
        };
  
      const TARGET_WIDTH = 329;
      const productImages = document.querySelectorAll('img[data-color-handle][data-src]');
      if (!productImages.length) return;
  
      // STEP 1: Gather all unique keys from all data-src blocks
      const uniqueEnglishKeys = new Set();
  
      const parsedImageData = Array.from(productImages).map(img => {
        const dataSrcRaw = img.getAttribute('data-src');
        let colorImageMap = {};
        try {
          const json = dataSrcRaw.replace(/&quot;/g, '"').replace(/\s+/g, ' ').trim();
          colorImageMap = JSON.parse(json);
          Object.keys(colorImageMap).forEach(k => uniqueEnglishKeys.add(k));
        } catch (e) {
          console.error('Invalid data-src JSON:', e);
        }
        return { img, colorImageMap };
      });
  
      const englishKeys = Array.from(uniqueEnglishKeys);
      const translatedToFrench = await batchTranslateToFrench(englishKeys);
  
      // STEP 2: Build translation map: { french_normalized => english_key }
      const translationMap = {};
      englishKeys.forEach((key, i) => {
          const fr = normalize(translatedToFrench[i]);
          if (!fr) return;
        
          if (!translationMap[fr]) translationMap[fr] = [];
          translationMap[fr].push(key);
        
          // Add any manual overrides for this key
          if (customOverrides[key]) {
            customOverrides[key].forEach(manualFr => {
              const normalizedManualFr = normalize(manualFr);
              if (!translationMap[normalizedManualFr]) translationMap[normalizedManualFr] = [];
              translationMap[normalizedManualFr].push(key);
            });
          }
        });
  
      // STEP 3: Apply the correct image for each product
      parsedImageData.forEach(({ img, colorImageMap }) => {
        const frenchHandle = normalize(img.getAttribute('data-color-handle'));
  
        // First, try exact match
        let englishKey = null;
        const candidates = translationMap[frenchHandle];

        if (candidates) {
          englishKey = candidates.find(key => key in colorImageMap);
        }
  
        // Fallback 1: contains (already in place)
        if (!englishKey) {
          for (const frKey in translationMap) {
            if (frenchHandle.includes(frKey)) {
              englishKey = translationMap[frKey].find(key => key in colorImageMap);
              if (englishKey) break;
            }
          }
        }

        // Fallback 2: partial match — does any part of the English key appear in the French handle?
        if (!englishKey) {
          for (const frKey in translationMap) {
            for (const key of translationMap[frKey]) {
              const parts = key.split('-');
              if (parts.some(part => frenchHandle.includes(part))) {
                if (key in colorImageMap) {
                  englishKey = key;
                  break;
                }
              }
            }
            if (englishKey) break;
          }
        }

        // Fallback 3: use the first image in the object
        if (!englishKey) {
          const firstKey = Object.keys(colorImageMap)[0];
          if (firstKey) {
            englishKey = firstKey;
            console.warn(`Using first image as fallback for: "${frenchHandle}"`);
          }
        }
  
        if (!englishKey) {
          console.warn(`No match for French handle: "${frenchHandle}"`);
          return;
        }
  
        const matchedUrl = colorImageMap[englishKey];
        if (!matchedUrl) {
          console.warn(`No URL found for English key: "${englishKey}"`);
          return;
        }
  
        const tempImg = new Image();
        tempImg.onload = function () {
          const aspectRatio = this.width / this.height;
          const height = Math.round(TARGET_WIDTH / aspectRatio);
          img.src = matchedUrl;
          img.setAttribute('height', height);
          img.setAttribute('width', TARGET_WIDTH);
        };
        tempImg.src = matchedUrl;
      });
  
    function normalize(str) {
      return (str || '')
        .toLowerCase()
        .trim()
        .replace(/\n/g, '')
        .normalize("NFD")                   // separate accents
        .replace(/[\u0300-\u036f]/g, '')   // strip accents
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9\-]/g, '');
    }
  
    async function batchTranslateToFrench(englishValues) {
      const query = englishValues.join('\n');
      try {
        const res = await fetch(
          `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=fr&dt=t&q=${encodeURIComponent(query)}`
        );
        const data = await res.json();
        return data[0].map(pair => pair[0]);
      } catch (err) {
        console.error('Translation failed:', err);
        return englishValues;
      }
    }

  }

  // Create mutation observer
  const observer = new MutationObserver(handleMutations);

  // Start observing
  const observeContainer = document.querySelector('ul#CollectionGrid');
  observer.observe(observeContainer, {
    childList: true,
    subtree: true,
  });
});
